import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IListMobileLicenseUser } from '../../common/types/userTypes';
import { Status } from '../../common/constants';
import { getMobileLicenseUsersUrl } from '../../config';
import api from '../../api';
import { getCookie } from "../../common/utils";

const initialState: IListMobileLicenseUser = {
  users: [],
  status: Status.IDLE,
  error: null,
};

export const getMobileLicenseUsersList: any = createAsyncThunk('listMobileLicenseUsers', async (orgId?: string) => {
  try {
    const organizationId: string = orgId? orgId : getCookie('organizationId');
    const response = await api.get(getMobileLicenseUsersUrl+`?orgId=${organizationId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
});

const mobileLicenseUserSlice = createSlice({
  name: 'listMobileLicenseUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMobileLicenseUsersList.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(getMobileLicenseUsersList.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.users = action.payload;
      })
      .addCase(getMobileLicenseUsersList.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

type Selector = {
    getMobileLicenseUsersApi: ReturnType<typeof mobileLicenseUserSlice.reducer>;
};

export const selector = (store: Selector) => store['getMobileLicenseUsersApi'];

export default mobileLicenseUserSlice.reducer;
